var dayNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
export var dayOptions = dayNames.map(function(value, index) {
    return {
        id: "day-".concat(index),
        value: index,
        inactive: "".concat(value, "?"),
        active: value
    };
});
